"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioPermissions = void 0;
var constants_1 = require("@hobt/constants");
exports.PortfolioPermissions = {
    PiFileShare: {
        AddAttachment: {
            modules: [constants_1.Module.PiFileShare],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
        Read: {
            modules: [constants_1.Module.PiFileShare],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
        Submit: {
            modules: [constants_1.Module.PiFileShare],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
        Delete: {
            modules: [constants_1.Module.PiFileShare],
            roles: [constants_1.UserRole.PortfolioAnalyst],
        },
    },
    PiPurposeTest: {
        Read: {
            modules: [constants_1.Module.PiPurposeTest],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
        Update: {
            modules: [constants_1.Module.PiPurposeTest],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
    },
    PiRequest: {
        AddAttachment: {
            modules: [constants_1.Module.PiFileShare],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
        Submit: {
            modules: [constants_1.Module.PiFileShare],
            roles: [constants_1.UserRole.ApprovedLender, constants_1.UserRole.PortfolioAnalyst],
        },
    },
};
